export default __webpack_public_path__ + "static/media/asthmaGo_logo.16592543.png";